import * as service from './service'
export default {
  namespace: 'recruitSureIdentity',
  state: {
    submitInfoData: {}
  },
  effects: {
    * submitInfo ({ payload }, { call, put }) {
      const res = yield call(service.submitInfo, payload)
      yield put({
        type: 'save',
        payload: {
          submitInfoData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
